import type { SVGProps } from 'react';
const SvgSewage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.938 5.91A.92.92 0 0 0 13 5a.92.92 0 0 0-.937.91v.304H8.937A.92.92 0 0 0 8 7.125c0 .505.418.91.938.91h3.124v3.036H4.876v-.303a.92.92 0 0 0-.937-.91.92.92 0 0 0-.938.91v10.321c0 .505.418.911.938.911.519 0 .937-.406.937-.91v-.304h16.25v.303c0 .505.418.911.938.911.519 0 .937-.406.937-.91V10.767a.92.92 0 0 0-.937-.91.92.92 0 0 0-.938.91v.303h-7.187V8.036h3.124c.52 0 .938-.406.938-.911a.92.92 0 0 0-.937-.91h-3.125zM4.874 18.965v-6.071h16.25v6.071z"
    />
  </svg>
);
export default SvgSewage;
